import {
    createSearchParams,
    useNavigate,
    useSearchParams,
} from 'react-router-dom'
import {
    List,
    ListItem,
    ListItemText,
    Stack,
    Typography,
    useTheme,
} from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useEffect, useState } from 'react'
import { useInnsynContext } from '../context/InnsynContextProvider'
import { useIntl } from 'react-intl'
import colors from '../styles/colors.scss'
import { getOmraadeNameKey } from '../services/TextService'

interface props {
    pathname: string
    rightEar?: boolean
}

export const LocationListItem = ({ pathname, rightEar }: props) => {
    const navigate = useNavigate()
    const theme = useTheme()
    const intl = useIntl()
    const [query] = useSearchParams()
    const { geografi } = useInnsynContext()
    const [calculatedText, setCalculatedText] = useState<string>(
        intl.formatMessage({ id: 'search-page.title-2' })
    )
    const areaStringArray = query.getAll('a')
    const districtStringArray = query.getAll('d')
    const areas =
        geografi &&
        (geografi.filter((val) => {
            return areaStringArray.find((el) => {
                return val.omraadeId === parseInt(el)
            })
        }) as Area[])
    const siidaStringArray = query.getAll('s')
    const districts = areas && areas.map((area) => area.distrikter).flat()

    const areaContainingSiida = () => {
        const area = geografi?.filter(
            (area) =>
                area.distrikter?.filter(
                    (distrikt) =>
                        distrikt.siidaer.filter((siida) =>
                            siidaStringArray.includes(siida.siidaId.toString())
                        ).length > 0
                ).length > 0
        )
        return area || []
    }

    const districtContainingSiida = () => {
        const district = areaContainingSiida()[0].distrikter.filter(
            (dist) => dist.siidaer.length > 0
        )
        return district || []
    }

    useEffect(() => {
        if (areas?.length === 0 && siidaStringArray.length === 0) {
            setCalculatedText(intl.formatMessage({ id: 'search-page.title-2' }))
            return
        }
        let districtCount = 0
        if (
            siidaStringArray.length > 0 &&
            !areas?.includes(areaContainingSiida()[0])
        ) {
            areas?.push(areaContainingSiida()[0])
        }
        areas?.forEach((area) => {
            const selectedDistrictsInArea = districtStringArray.filter(
                (districtIdCondition) =>
                    area.distrikter
                        .map((district) => district.distriktId)
                        .includes(parseInt(districtIdCondition))
            )
            if (
                siidaStringArray.length > 0 &&
                area.omraadeId === areaContainingSiida()[0].omraadeId
            ) {
                selectedDistrictsInArea.push(
                    districtContainingSiida()[0]?.distriktId?.toString()
                )
            }
            if (selectedDistrictsInArea.length > 0) {
                districtCount += selectedDistrictsInArea.length
            } else {
                districtCount += area.distrikter.length
            }
        })
        let buildText = `${districtCount > 0 ? `(${districtCount})` : ''} ${
            areas &&
            areas
                .map((area) =>
                    intl.formatMessage({
                        id: getOmraadeNameKey(area.omraadeId),
                    })
                )
                .join(', ')
        }`
        setCalculatedText(buildText)
    }, [areas, districts])

    const selectArea = () => {
        navigate(
            {
                pathname: pathname,
                search: `?${createSearchParams(query)}`,
            },
            { state: { isRightEar: rightEar } }
        )
    }

    return (
        <List component='nav' aria-label='Velg reinbeiteområde og distrikt'>
            <Stack
                direction='row'
                sx={{
                    marginTop: '0.25rem',
                    outline: `solid ${theme.palette.primary.main} 0.5px`,
                    borderRadius: '4pt',
                    boxShadow: `0px 1.5px 5px ${colors.iconGray}`,
                    width: '100%',
                }}>
                <ListItem
                    button
                    onClick={() => selectArea()}
                    sx={{ marginTop: '0.25rem', marginBottom: '0.25rem' }}>
                    <ListItemText
                        disableTypography={true}
                        primary={
                            <Typography
                                sx={{
                                    fontWeight: '300',
                                    fontSize:
                                        window.screen.width < 370
                                            ? '1rem'
                                            : '1.25rem',
                                    whiteSpace: 'nowrap',
                                    overflow: ' hidden',
                                    textOverflow: 'ellipsis',
                                }}>
                                {calculatedText}
                            </Typography>
                        }
                        sx={{
                            marginLeft: '1rem',
                            color: colors.greyText,
                        }}
                    />
                    <ArrowForwardIosIcon fontSize='small' />
                </ListItem>
            </Stack>
        </List>
    )
}

export default LocationListItem
